export function isClientDto(obj) {
  return !!obj.primaryContactExpanded;
}
